<template>
  <div class="box">
    <el-radio v-for="item of radioNavList" :key="item" v-model="radio" :label="item">{{item}}</el-radio>
  </div>
</template>

<script>
export default {
  name: "RadioNav",
  props: {
    radioStr: {
      type: String
    },
    radioNavList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      radio: null
    };
  },

  created() {
    this.radio = this.radioStr;
  },

  watch: {
    radio(newVal) {
      this.$emit("update:radioStr", newVal);
    }
  }
};
</script>

<style lang='less' scoped>
/deep/.el-radio__input {
  display: none;
}

/deep/.el-radio__label:hover {
  color: #24ba58;
}

/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #24ba58;
}

/deep/.el-radio {
  color: #333;
}
</style>